import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCreateRecipientBank = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 25,
	viewBox: "0 0 25 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_20154_58688)",
		children: [/* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 24,
			height: 24,
			fill: "#EF4444"
		}), /* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip1_20154_58688)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M7.02539 11.4859L11.891 8.24219L16.7566 11.4859",
					stroke: "white",
					strokeWidth: .810938,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M7.02539 17.9746H16.7566",
					stroke: "white",
					strokeWidth: .810938,
					strokeLinecap: "square",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M8.64746 16.3512V13.1074",
					stroke: "white",
					strokeWidth: .810938,
					strokeLinecap: "square",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M10.8105 16.3512V13.1074",
					stroke: "white",
					strokeWidth: .810938,
					strokeLinecap: "square",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M12.9727 16.3512V13.1074",
					stroke: "white",
					strokeWidth: .810938,
					strokeLinecap: "square",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M15.1348 16.3512V13.1074",
					stroke: "white",
					strokeWidth: .810938,
					strokeLinecap: "square",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M19.1902 6.41797L16.6814 8.85078L15.541 7.63437",
					stroke: "white",
					strokeWidth: .790664,
					strokeLinecap: "square"
				})
			]
		})]
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_20154_58688",
		children: /* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 24,
			height: 24,
			rx: 7.29844,
			fill: "white"
		})
	}), /* @__PURE__ */ _jsx("clipPath", {
		id: "clip1_20154_58688",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 14.5969,
			height: 14.5969,
			fill: "white",
			transform: "translate(5.20117 5.20117)"
		})
	})] })]
});
export default SvgCreateRecipientBank;
